<app-dropdown
  [name]="name() + '_dropdown'"
  [(ngModel)]="dropdownModel"
  (ngModelChange)="onTagSelected($event)"
  [label]="label()"
  [options]="unselectedTags()"
  [placeholder]="dropdownPlaceholder()"
  [disabled]="unselectedTags().length === 0"
  [required]="required()"
  [isLoading]="isLoading()"
  class="mb-0"
  optionValue="id"
  optionLabel="name"
></app-dropdown>
<app-tags [tags]="selectedTagArray()" (tagRemoved)="removeTag($event)" class="flex-1" />
